export default __webpack_public_path__ + "img/task_schedule.png";